/// <reference path="./notificationSetting.base.section.ts" />

module Meevo.Plugins.NotificationSetting {
    "use strict";
    export class ClientMiscellaneousSection extends NotificationSettingBaseSection {

        public referralThankYouDateRange: any;

        constructor(
            protected isApplicationModeCO: boolean,
            protected isSingleLocation: boolean,
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            sectionSecurityKey?: string
        ) {
            super(isApplicationModeCO, isSingleLocation, sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey);

            this.referralThankYouDateRange = [
                { id: Meevo.Model.ReferralThankYouDateRangeEnum.Yesterday, displayName: "LABEL_YESTERDAY" },
                { id: Meevo.Model.ReferralThankYouDateRangeEnum.LastWeek, displayName: "LABEL_LAST_WEEK" },
                { id: Meevo.Model.ReferralThankYouDateRangeEnum.LastMonth, displayName: "LABEL_LAST_MONTH" }
            ];
        }

        public activate(): void {
            super.activate();

            if (this.model && this.model.communicationTypeNotifications) {
                var clientReferralThankYou: any = _.findWhere(this.model.communicationTypeNotifications, { communicationType: 11045516, communicationTypeUser: 2088 })
                if (clientReferralThankYou && clientReferralThankYou.options.settings) {
                    var sendReferralThankYouDateRangeSetting: any = _.findWhere(clientReferralThankYou.options.settings, { displayName: "SendReferralThankYouDateRange" });
                    clientReferralThankYou.options.sendReferralThankYouDateRange = sendReferralThankYouDateRangeSetting.metadata.locationValue;
                }
            }
        }

    }
}